import { formatCurrency as s, centsToNumber as e } from "../../../../utils.js";
import { Model as i } from "../../model.js";
class h extends i {
  constructor(t) {
    super(), this.channel = t.channel, this.id = t.id, this.status = t.status, this.name = t.name, this.created = t.created, this.notes = t.notes, this.ticketSummary = t.ticketSummary, this.ticketCashback = t.ticketCashback, this.ticketDelivery = t.ticketDelivery, this.ticketFees = t.ticketFees, this.ticketItemList = t.ticketItemList, this.ticketComboList = t.ticketComboList, this.ticketPromotionList = t.ticketPromotionList, this.ticketTaxes = t.ticketTaxes, this.ticketId = t.ticketId, this.ticketNumber = t.ticketNumber, this.ticketDatetime = t.ticketDatetime, this.ticketService = t.ticketService, this.assignedPos = t.assignedPos, this.scope = t.scope, this.history = t.history;
  }
  formatAmount(t) {
    return s(t, this.ticketSummary.currency);
  }
  getFormattedPaidCashback() {
    var t;
    return this.formatAmount(
      e(((t = this.ticketCashback) == null ? void 0 : t.paid) ?? 0)
    );
  }
  getFormattedEarnedCashback() {
    var t;
    return this.formatAmount(
      e(((t = this.ticketCashback) == null ? void 0 : t.earned) ?? 0)
    );
  }
}
export {
  h as TicketModel
};
//# sourceMappingURL=ticket.model.js.map
